import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { Message, MessageSections } from "../../../components/message/message";
import BarekamButton, { ActionbarButtons } from "../../../components/button";
import BarekamText from "../../../components/text";

import { Title } from "../Title/Title";

import onlineStoresService from "../../../../services/online-stores-service";
import { OnlineStoresModel } from "../../../shared/models/onlineStoresModel";
import { useNavigate, useParams } from "react-router-dom";
import OnlineStore from "./OnlineStore/OnlineStore";
import Container from "../Container/Container";

const OnlineStores: React.FC = () => {
  const navigate = useNavigate();
  const [storeLogos, setStoreLogos] = useState<OnlineStoresModel[] | []>([]);
  const { language } = useParams();

useEffect(() => {
  onlineStoresService.getStores().then(stores => {
    const data = stores?.data.filter(item => item.featured === true);
    setStoreLogos(data);
  })
}, [])

  return (
    <Container>
      <Title variant="h2">
        <Message
          messageKey={"online_stores_title"}
          sectionId={MessageSections.MAIN}
        />
      </Title>
      <Grid container sx={{ marginBottom: "60px" }} justifyContent="center">
        {storeLogos.map((logo, index) => (
          <OnlineStore {...logo} key={index} />
        ))}
      </Grid>
      <BarekamButton
        type={ActionbarButtons.NEW}
        size={"l"}
        onClick={() => navigate(`/${language}/online-stores`)}
        endIcon={<ArrowForwardIcon />}
      >
        <BarekamText variant={"m"} fontWeight={600} align={"center"}>
          <Message
            messageKey={"online_stores_button"}
            sectionId={MessageSections.MAIN}
          />
        </BarekamText>
      </BarekamButton>
    </Container>
  );
};

export default OnlineStores;
